module.exports = __webpack_public_path__ + "img/instructions_2@3x.c2efebb9.png";